import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maskEmailCtn',
    standalone: false
})
export class MaskEmailCtnPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let result;
    if (value && args && (args === 'designatedCTN' || args === 'contactCTN')) {
      result = this.maskCtn(value);
    } else if (value && args && (args === 'userid' || args === 'contactEmail')) {
      result = this.maskEmail(value);
    } else if (value && args && args === 'displayCTN') {
      result = this.displayFormatCTN(value);
    }
    return result;
  }

  maskEmail(value: string): string | undefined {
    if (value) {
      const len = value.split('@')[0].length;
      const temp1 = value.split('@')[0].slice(0, 1);
      let temp2 = value.split('@')[0].slice(1, len);
      temp2 = temp2.replace(/./gi, '*');
      return `${temp1}*${temp2}${value.split('@')[1]}`;
    }
  }

  maskCtn(value: string): string | undefined {
    if (value) {
      let temp1 = value.slice(0, 6);
      const temp2 = value.slice(6, 10);
      temp1 = temp1.replace(/./gi, '*');
      return `${temp1}${temp2}`;
    }
  }

  displayFormatCTN(value: string): string | undefined {
    if (value) {
      const temp1 = value.slice(0, 3);
      const temp2 = value.slice(3, 6);
      const temp3 = value.slice(6, 10);
      return `(${temp1}) ${temp2} - ${temp3}`;
    }
  }

}
